import { useEffect } from 'react';

export const usePaste = (handler?: ((event: ClipboardEvent) => void) | null) => {
    useEffect(() => {
        if (!handler) {
            return undefined;
        }

        window.addEventListener('paste', handler);

        return () => window.removeEventListener('paste', handler);
    }, [handler]);
};
